var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "nav-icon-calendar.757f9c86.png","uri@2x": __webpack_public_path__ + "nav-icon-calendar.bcf57b60.png","uri@3x": __webpack_public_path__ + "nav-icon-calendar.df871123.png",
    width: 20,
    height: 22
});